import script from "./ProgramVersionTargetFormFields.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramVersionTargetFormFields.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramVersionTargetFormFields.vue?vue&type=style&index=0&id=f463d5f2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f463d5f2"]])

export default __exports__